export default {
    success: '#43a047',
    error: '#e64a19',
    warning: '#fbc02d',
    info: '#039be5',
};
